export default "__VITE_ASSET__ujGp$gi5kRfgY_zCHF78LQ__"